import React from "react"
import { FormikTextField } from "../../../../../../../shared/components/forms/Formik"
import { PrivatePersonDetailsFormValues } from "../../billReceiversTypes"
import { DetailsAddressFormSection } from "./DetailsAddressFormSection"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

type PrivatePersonProps = Readonly<{
    isMerchantAdmin: boolean
}>

export function PrivatePersonForm({ isMerchantAdmin }: PrivatePersonProps) {
    return (
        <>
            {isMerchantAdmin && (
                <LocalizedStrict
                    id="bill-receivers-form-label-debtor-number"
                    attrs={{ label: true, placeholder: true }}
                >
                    <FormikTextField<PrivatePersonDetailsFormValues>
                        name="debtorNumber"
                        label="Debtor number"
                        placeholder="Identifier of debtor in your accounting system"
                        fullWidth
                    />
                </LocalizedStrict>
            )}
            <LocalizedStrict id="bill-receivers-form-label-name" attrs={{ label: true }}>
                <FormikTextField<PrivatePersonDetailsFormValues> name="name" label="Name(*)" fullWidth />
            </LocalizedStrict>
            <DetailsAddressFormSection />
            <LocalizedStrict id="bill-receivers-form-label-telephone" attrs={{ label: true }}>
                <FormikTextField<PrivatePersonDetailsFormValues> name="telephone" label="Telephone (*)" fullWidth />
            </LocalizedStrict>
        </>
    )
}
